import backendMultipleUISelectTemplate from './backendMultipleUISelect.html';
import {CommonViewController} from "../../controller/CommonViewController";

/** @ngInject */
export function backendMultipleSelect() {
    return {
        restrict: 'E',
        scope: {
            kind: '=',
            url: '=',
            filterType: '=',
            property: '='
        },
        transclude: 'true',
        templateUrl: backendMultipleUISelectTemplate,
        controller: BackendMultipleSelectController,
        controllerAs: 'backendMultipleSelectController'
    };
}

/** @ngInject */
export class BackendMultipleSelectController extends CommonViewController {

    constructor($scope, userService, arsMainDependencies) {
        super($scope, userService, arsMainDependencies);

        this.backendService = this.getUserAccountBackendService(userService, this.$scope.property.sort);

        // element with selection
        if(!this.$scope.property.selectAll && this.$scope.property.selectionList) {
            // groups export populates lists with object results
            if(this.$scope.property.selectionList[0].constructor === String) {
                // VALUE SERIES special character ']'
                this.$scope.property.selectionList = this.$scope.property.selectionList
                    .map(el => el.substr(0, el.indexOf(']') !==-1 ? el.indexOf(']') : el.length));
                this.populateSelection({loadKey: this.$scope.property.selectionList});
            }

        } else if(this.$scope.property.selectAll && this.state._params.tableFilter) {
            this.backendService.resetPaging(this.state._params.tableCount);
            this.populateSelection(this.state._params.tableFilter);
        }
    }

    populateSelection(filter) {
        // transmit searchvalue
        return this.backendService.postUserData( this.$scope.url, filter).then((data) => {
            if(data) {
                this.$scope.property.selectionList = this.$scope.property.selectionList ?
                this.$scope.property.selectionList = data.filter(opt =>
                    this.$scope.property.selectionList.indexOf(opt.id) !== -1) : data;
            }
        });
    }

    reloadData (searchValue) {
        this.backendService.resetPaging(100);
        const filter = searchValue !=='' ? {freeText: [searchValue]} : {};
        // transmit searchvalue
        return this.backendService.postUserData(this.$scope.url, filter).then((data) => {
            if(data) {
                // populate by type code and name
                this.dataList = data;
            }
        });
    }
}
